/*!
 * PropPerks storefront — gift chooser modal
 * Ported from the incumbent Milestones app block by scripts/port-frontend.py (do not hand-edit
 * the ported sections without updating the script). Config comes from window.PropPerks,
 * set in snippets/propperks.liquid.
 */
(function() {
    function esc(str) { var d = document.createElement('div'); d.textContent = str; return d.innerHTML; }

    var testMode = false;
    var testModeActive = testMode && new URLSearchParams(window.location.search).get('pp_test') !== '1';
    var isCartPage = window.location.pathname.indexOf('/cart') !== -1;

    var PP = window.PropPerks || {};
    var PP_PROXY = PP.proxy || '/apps/propperks';
    var customerId = PP.customerId || null;
    if (!customerId) return;
    var lastCartToken = null;

    // Replaces the incumbent's eligibility endpoint: status (server) + region-resolved tiers
    // (server) + own-product total (client, display only). The claim re-verifies everything.
    function ownTotal(cart, marketplace) {
      var total = 0, ownLines = 0;
      cart.items.forEach(function(item) {
        if (marketplace[item.product_id]) return;
        var isGift = item.properties && item.properties['Free Gift'];
        var unitPrice = item.price || item.original_price || 0;
        if (isGift) {
          if (item.quantity > 1) total += (unitPrice * (item.quantity - 1)) / 100;
        } else {
          total += (unitPrice * item.quantity) / 100;
          if (unitPrice > 0 && item.quantity > 0) ownLines++;
        }
      });
      return ownLines ? total : 0;
    }
    // Display only; rounds UP to the nearest 5 so a tier never looks reached below its GBP threshold.
    function convertedThreshold(gbp) { return currencyRate !== 1 ? Math.ceil((gbp * currencyRate) / 5 - 1e-9) * 5 : gbp; }
    // Server-authoritative unlock (review finding 14). When the tiers payload carries a judged
    // verdict the server has priced the real basket in GBP, so it alone decides which tiers are
    // unlocked: every active tier at or below unlockedTierId, as the claim check does. Without
    // one the converted-threshold estimate applies: an older Worker sends no unlockedTierId, and
    // a basket the server didn't judge comes back judged:false or with a null ownSubtotalGbp
    // (pass-3 P3-2). A Worker that predates `judged` counts as judged when the subtotal is a number.
    function verdictKnown(tiersData) {
      return !!tiersData && (tiersData.judged === true || tiersData.judged === undefined) && typeof tiersData.ownSubtotalGbp === 'number';
    }
    function serverUnlockedIds(tiersData) {
      if (!tiersData || !tiersData.tiers || !Object.prototype.hasOwnProperty.call(tiersData, 'unlockedTierId') || !verdictKnown(tiersData)) return null;
      var top = null;
      tiersData.tiers.forEach(function(t) { if (t.id === tiersData.unlockedTierId) top = t; });
      var ids = {};
      if (top) tiersData.tiers.forEach(function(t) { if (t.threshold <= top.threshold) ids[t.id] = 1; });
      return ids;
    }
    function ownGbpOf(tiersData) { return tiersData && typeof tiersData.ownSubtotalGbp === 'number' ? tiersData.ownSubtotalGbp : null; }
    function tierUnlocked(t, ids, total) { return ids ? !!ids[t.id] : total >= convertedThreshold(t.threshold); }
    function remainingToUnlock(thresholdGbp, data, total) {
      var r = data && data._unlockedIds && typeof data._ownGbp === 'number'
        ? (thresholdGbp - data._ownGbp) * currencyRate
        : convertedThreshold(thresholdGbp) - total;
      return Math.max(0.01, Math.ceil(r * 100 - 1e-6) / 100).toFixed(2);
    }
    function tiersUrl(cart) {
      var u = PP_PROXY + '?action=tiers&currency=' + encodeURIComponent(currencyCode);
      if (cart && cart.token) u += '&cart=' + encodeURIComponent(cart.token);
      if (PP.country) u += '&country=' + encodeURIComponent(PP.country);
      return u;
    }
    function buildModalData(status, tiersData, cart) {
      var allTiers = (tiersData && tiersData.tiers) || [];
      var marketplace = {};
      ((tiersData && tiersData.marketplaceProductIds) || []).forEach(function(id) { marketplace[id] = 1; });
      var total = ownTotal(cart, marketplace);
      var ids = serverUnlockedIds(tiersData);
      var ownGbp = ownGbpOf(tiersData);
      if (!status || !status.eligible || !allTiers.length) return { eligible: false, tiers: [], gifts: [], _allTiers: allTiers, _cartTotal: total, _unlockedIds: ids, _ownGbp: ownGbp };
      var unlocked = allTiers.filter(function(t) { return tierUnlocked(t, ids, total) && t.gifts && t.gifts.length; });
      var top = unlocked[unlocked.length - 1] || allTiers[0];
      return { eligible: true, tier: top, tiers: unlocked, gifts: unlocked.length ? top.gifts : [], orderNumber: status.orderNumber, _allTiers: allTiers, _cartTotal: total, _unlockedIds: ids, _ownGbp: ownGbp };
    }
    function loadModalData() {
      var cartRef;
      return fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          cartRef = cart;
          lastCartToken = cart.token || null;
          var cartCurrency = cart.currency || 'GBP';
          if (cartCurrency !== 'GBP' && window.Shopify && window.Shopify.currency && window.Shopify.currency.active === cartCurrency) {
            currencyRate = parseFloat(window.Shopify.currency.rate) || 1;
            currencyCode = cartCurrency;
          }
          window.__pp_currentBasketSkus = basketSkusFromCart(cart);
          // The progress bar's lookup for this basket, shared and kept per cart token +
          // quantities (pass-3 P3-2): no second cart-reading lookup on page load.
          var tiersReq = typeof window.__pp_loadTiers === 'function'
            ? window.__pp_loadTiers(cart)
            : fetch(tiersUrl(cart)).then(function(r) { return r.json(); });
          return Promise.all([
            fetch(PP_PROXY + '?action=status&customer_id=' + customerId).then(function(r) { return r.json(); }),
            tiersReq
          ]);
        })
        .then(function(res) {
          if ((res[0] && res[0].disabled) || (res[1] && res[1].disabled)) return null;
          return { data: buildModalData(res[0], res[1], cartRef), cart: cartRef };
        });
    }

    // ── Claim flow helpers (review findings 14, 18, 26) ──
    // Claim-in-flight marker: localStorage so every tab's progress bar sees it, plus this tab's
    // own copies (sessionStorage, which survives the navigation, and an in-page variable for when
    // storage is blocked). Another tab's claim shares the localStorage key and may overwrite or
    // clear it, but never this tab's copies. "<timestamp>:<attempt>", so an attempt only ever
    // clears its own.
    var CLAIM_MARKER = 'pp_claim_inflight';
    var claimAttemptSeq = 0;
    var claimAttemptActive = false;
    // A successful claim navigates away with the attempt still marked active; if the browser
    // later restores this page from its back/forward cache, let the customer claim again.
    if (window.addEventListener) window.addEventListener('pageshow', function(e) { if (e && e.persisted) claimAttemptActive = false; });
    function markClaimInFlight(id) {
      var v = Date.now() + ':' + id;
      window.__pp_claimInFlight = v;
      try { window.localStorage.setItem(CLAIM_MARKER, v); } catch (e) {}
      try { window.sessionStorage.setItem(CLAIM_MARKER, v); } catch (e) {}
    }
    function clearClaimInFlight(id) {
      if (String(window.__pp_claimInFlight || '').split(':')[1] === String(id)) window.__pp_claimInFlight = null;
      ['localStorage', 'sessionStorage'].forEach(function(kind) {
        try {
          var s = window[kind];
          var v = s.getItem(CLAIM_MARKER);
          if (v && v.split(':')[1] === String(id)) s.removeItem(CLAIM_MARKER);
        } catch (e) {}
      });
    }
    // Why a claim didn't go through, in the customer's words. Keys are the Worker's claim error
    // codes plus the storefront's own failure kinds (add_failed, basket_failed, generic).
    // claims_blocked (decision D17): staff are reviewing an earlier gift order, so claims stay
    // closed until they have; say so politely and point the customer to us.
    var CLAIM_MESSAGES = {
      below_tier_threshold: 'Your basket doesn\'t quite reach this gift\'s tier yet. Our tiers are set in pounds sterling, so add a little more or choose a gift from a lower tier.',
      gift_not_in_tier: 'That gift isn\'t available at the moment. Please choose another.',
      wrong_region: 'That gift can\'t be sent to your delivery region. Please choose another.',
      not_fulfillable: 'Sorry, that gift is out of stock for your delivery location. Please choose another.',
      no_own_products: 'Free gifts unlock with Prop Options products. Add one of ours to your basket to claim yours.',
      already_claimed: 'You\'ve already claimed the free gift for this order, perhaps on an order that\'s awaiting payment. If that doesn\'t sound right, please get in touch and we\'ll sort it out.',
      milestone_exceeded: 'You\'ve already received every free gift in our programme. Thank you for being such a loyal customer!',
      claims_blocked: 'Sorry, we can\'t add a free gift to your order just now. Please get in touch with the Prop Options team and we\'ll be happy to help.',
      basket_too_large: 'Your basket has too many different products for us to check online. Please remove a few, or get in touch and we\'ll add your free gift for you.',
      history_too_long: 'We can\'t check your order history online just now. Please get in touch with the Prop Options team and we\'ll add your free gift for you.',
      cart_unreadable: 'We couldn\'t check your basket just now. Please refresh the page and try again.',
      rate_limited: 'You\'ve tried a few times now. Please wait a little while, then try again.',
      temporarily_unavailable: 'We couldn\'t create your free gift just now. Please try again in a moment.',
      claim_conflict: 'We couldn\'t create your free gift just now. Please try again in a moment.',
      add_failed: 'Sorry, we couldn\'t add that gift to your basket. It may be out of stock, so please choose another.',
      basket_failed: 'We couldn\'t update your basket. Please refresh the page and check your basket before trying again.',
      generic: 'Something went wrong. Please try again. Your basket hasn\'t been changed.'
    };
    // Refusals where another choice may work: back to the gift list. Used-slot and blocked
    // refusals: stop offering (a retry can't succeed and costs one of the hourly attempts).
    var CLAIM_CHOOSE_AGAIN = { below_tier_threshold: 1, gift_not_in_tier: 1, wrong_region: 1, not_fulfillable: 1, no_own_products: 1, add_failed: 1 };
    var CLAIM_NO_RETRY = { already_claimed: 1, milestone_exceeded: 1, claims_blocked: 1, history_too_long: 1 };
    function claimError(reason) { var e = new Error(reason); e.ppReason = reason; return e; }
    function later(ms) { return new Promise(function(resolve) { setTimeout(resolve, ms); }); }
    function showClaimWarning(msg) {
      var warnEl = document.getElementById('pp-discount-warning');
      if (!warnEl) return;
      warnEl.textContent = msg || '';
      warnEl.style.display = msg ? 'block' : 'none';
    }
    function isGiftLine(item) { return !!(item.properties && item.properties['Free Gift']); }
    function sameGiftLine(item, numericId, props) {
      if (String(item.variant_id) !== String(numericId) || !isGiftLine(item)) return false;
      for (var k in props) {
        if (Object.prototype.hasOwnProperty.call(props, k) && String(item.properties[k] || '') !== String(props[k])) return false;
      }
      return true;
    }
    function readCart() {
      return fetch('/cart.js').then(function(r) {
        if (!r.ok) throw new Error('cart HTTP ' + r.status);
        return r.json();
      });
    }
    function removeLines(keys) {
      var updates = {};
      keys.forEach(function(k) { updates[k] = 0; });
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function(r) { if (!r.ok) throw new Error('cart update HTTP ' + r.status); });
    }
    // Paid units on a removed gift line are put back as an ordinary line (pass-5 P5-12; the
    // progress bar's restorePaidUnits, which says why it is tried only once).
    function restorePaidUnits(lines) {
      var items = [];
      lines.forEach(function(item) {
        if (item.quantity > 1) items.push({ id: item.variant_id, quantity: item.quantity - 1 });
      });
      if (!items.length) return Promise.resolve();
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function() {}, function() {});
    }
    // The claim's answer. Rejections are HTTP 200 {error}; 429 / 503 carry {error} too.
    function readClaimResponse(r) {
      return r.json().then(function(d) { return d || {}; }, function() {
        return { error: r.status === 429 ? 'rate_limited' : r.status === 503 ? 'temporarily_unavailable' : 'generic' };
      });
    }
    // Adds the gift line and resolves with its line key. A refusal (e.g. out of stock) adds
    // nothing; a lost response is settled by looking for the line (only called when no
    // identical line was in the basket before, so a match can only be the one just added).
    // Only called after approval, when the new code must be applied whatever happens: if the
    // basket can't be read either, the outcome is unknown and it resolves with null so the swap
    // carries on and the code is applied. A line that was in fact added is then kept and
    // discounted; if none was, the code discounts nothing and the bar offers the gift again.
    function addGiftLine(numericId, props) {
      function findNewLine() {
        return readCart().then(function(cart) {
          for (var i = 0; i < cart.items.length; i++) {
            if (sameGiftLine(cart.items[i], numericId, props)) return cart.items[i].key;
          }
          throw claimError('add_failed');
        }, function(err) {
          console.error('[PropPerks] Gift line may not have been added; applying the new code anyway:', err);
          return null;
        });
      }
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(numericId, 10), quantity: 1, properties: props }] })
      }).then(function(r) {
        if (!r.ok) throw claimError('add_failed');
        return r.json().then(function(res) {
          var line = res && res.items && res.items[0];
          return line && line.key ? line.key : findNewLine();
        }, findNewLine);
      }, findNewLine);
    }
    // After an approved claim: put the new gift line in, then take the old gift lines out. An
    // identical gift line already in the basket is kept rather than re-added (it would merge).
    // Nothing is ever rolled back (pass-3 P3-16): the server deleted the old code when it
    // approved the claim, so the new line holds the only live code and must stay. The old lines
    // are worth nothing now (their paid units are put back, P5-12); removing them is tried
    // twice, then the swap carries on regardless and the new code is applied. A line left
    // behind is recorded for this tab's progress bar, which takes it out once the new code is
    // applied (P3-16 follow-on), and the checkout guard takes out any gift line the applied code
    // doesn't discount.
    var OLD_GIFT_LINES = 'pp_old_gift_lines'; // read by the progress bar
    function swapGiftLines(cart, numericId, props) {
      var keep = null, old = [];
      cart.items.forEach(function(item) {
        if (!keep && sameGiftLine(item, numericId, props)) keep = item.key;
        else if (isGiftLine(item)) old.push(item.key);
      });
      return (keep ? Promise.resolve(keep) : addGiftLine(numericId, props)).then(function() {
        if (!old.length) return;
        return removeLines(old)
          .catch(function() { return removeLines(old); })
          .then(function() { return restorePaidUnits(cart.items.filter(function(item) { return old.indexOf(item.key) !== -1; })); })
          .catch(function(err) {
            console.error('[PropPerks] Old gift line not removed:', err);
            try { sessionStorage.setItem(OLD_GIFT_LINES, JSON.stringify({ at: Date.now(), keys: old })); } catch (e) {}
          });
      });
    }

    var cachedData = null;
    var modalInitialised = false;
    var currencyRate = 1;
    var currencyCode = 'GBP';

    function getNonGiftTotal(cart) {
      var total = 0;
      cart.items.forEach(function(item) {
        var isGift = item.properties && item.properties['Free Gift'];
        var unitPrice = item.price || item.original_price || 0;
        if (isGift) {
          if (item.quantity > 1) {
            total += (unitPrice * (item.quantity - 1)) / 100;
          }
        } else {
          total += (unitPrice * item.quantity) / 100;
        }
      });
      return total.toFixed(2);
    }

    // Build a sorted, deduped, Free-Gift-excluded CSV of basket SKUs for
    // the server's basket-aware region resolver. The case-insensitive
    // property-key check (`Free Gift` vs `free gift`) keeps it robust
    // against theme variants. Returns '' for empty cart so the caller
    // can OMIT the basket_skus param entirely (distinguishes
    // present-but-empty from absent).
    function basketSkusFromCart(cart) {
      if (!cart || !cart.items) return '';
      var out = [];
      var seen = {};
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        var props = item.properties || {};
        var isGift = false;
        for (var k in props) {
          if (Object.prototype.hasOwnProperty.call(props, k) &&
              k.toLowerCase() === 'free gift' && props[k]) {
            isGift = true;
            break;
          }
        }
        if (isGift) continue;
        var sku = String(item.variant_id || '');
        if (!sku) continue;
        if (seen[sku]) continue;
        seen[sku] = 1;
        out.push(sku);
      }
      out.sort();
      return out.join(',');
    }

    // Expose global function for progress bar "Choose your gift" link
    // Always available regardless of test mode
    window.__pp_openGiftModal = function() {
      loadModalData()
        .then(function(res) {
          var data = res && res.data;
          if (data && data.eligible && data.gifts && data.gifts.length > 0) {
            cachedData = data;
            openModal(data);
          }
        })
        .catch(function() {});
    };

    // Reopen modal with cached data — no fetch needed, works after page load
    window.__pp_reopenGiftModal = function() {
      if (cachedData && cachedData.eligible && cachedData.gifts && cachedData.gifts.length > 0) {
        // Use latest cart total from progress bar if available
        if (typeof window.__pp_currentCartTotal === 'number') {
          cachedData._cartTotal = window.__pp_currentCartTotal;
        }
        openModal(cachedData);
        return true;
      }
      return false;
    };

    // Called by gift-progress.liquid AFTER a cart change re-fetches the
    // tiers endpoint with the new basket_skus. We update the cached
    // catalogue IN PLACE so the next modal open uses fresh data, but we
    // never destroy a selection the user has already made: if the modal
    // is open right now we just stash the update — doAddGift will check
    // selectedGiftStillExists before submitting and surface a friendly
    // message if the user's pick disappeared.
    //
    // CRITICAL VITALS SAFETY: this function MUST only be called from a
    // page-load-installed listener (cart:updated, the wrapped fetch/XHR
    // shim in gift-progress, on:cart-drawer:after-open). It must NEVER
    // be called from a click handler — Vitals wraps fetch/Promise after
    // first user interaction and the resulting .then() never fires.
    // gift-progress.liquid's maybeRefreshTiersForBasket enforces this.
    window.__pp_applyFreshTiers = function(tiersData) {
      if (!cachedData || !tiersData || !tiersData.tiers) return;
      cachedData._allTiers = tiersData.tiers;
      // If the gifts list (eligible-tier subset) also came back, swap that
      // for the next open. We do NOT mutate the currently-rendered modal —
      // openModal callers re-render from cachedData.
      // Region may have changed with the basket — refresh the unlocked subset from the new catalogue
      // (and the server's unlock verdict for the new basket, when it sends one).
      cachedData._unlockedIds = serverUnlockedIds(tiersData);
      cachedData._ownGbp = ownGbpOf(tiersData);
      if (cachedData.eligible) {
        var total = typeof window.__pp_currentCartTotal === 'number' ? window.__pp_currentCartTotal : cachedData._cartTotal;
        var unlocked = tiersData.tiers.filter(function(t) { return tierUnlocked(t, cachedData._unlockedIds, total) && t.gifts && t.gifts.length; });
        cachedData.tiers = unlocked;
        if (unlocked.length) { cachedData.tier = unlocked[unlocked.length - 1]; cachedData.gifts = cachedData.tier.gifts; }
      }
    };

    // Skip everything below if not on cart page or test mode active
    if (testModeActive) return;

    // Always fetch — tiers endpoint is cached (5min) and we need the data
    // for the button to work even if customer wasn't eligible at page load
    {
      var loadHasGift = false;
      loadModalData()
        .then(function(res) {
          if (!res) return;
          loadHasGift = res.cart.items.some(function(item) {
            return item.properties && item.properties['Free Gift'];
          });
          cachedData = res.data;
          // Mirrors the incumbent: keep a (locked-tiers-only) data object even when not
          // eligible, so the modal can render if the cart grows — the progress bar decides
          // whether the "Add Free Gift" button appears at all.
          if (!cachedData.eligible && cachedData._allTiers.length > 0) {
            cachedData = { eligible: true, tier: cachedData._allTiers[0], tiers: [], gifts: [], _allTiers: cachedData._allTiers, _cartTotal: cachedData._cartTotal,
              _unlockedIds: cachedData._unlockedIds, _ownGbp: cachedData._ownGbp };
          }
          window.__pp_cachedUnlockedCount = (cachedData.tiers || []).length;
          if (isCartPage && !loadHasGift && !sessionStorage.getItem('pp_skipped') && cachedData.tiers && cachedData.tiers.length > 0) {
            openModal(cachedData);
          }
        })
        .catch(function() {});
    }

    function openModal(data) {
      var overlay = document.getElementById('pp-overlay');
      var titleEl = document.getElementById('pp-title');
      var descEl = document.getElementById('pp-desc');
      var giftsEl = document.getElementById('pp-gifts');
      var addBtn = document.getElementById('pp-add-btn');
      var skipBtn = document.getElementById('pp-skip-btn');
      var warningEl = document.getElementById('pp-discount-warning');

      var selectedGift = null;
      var selectedVariantId = null;

      warningEl.style.display = 'none';

      // Reset event listeners by cloning buttons
      if (modalInitialised) {
        var newAddBtn = addBtn.cloneNode(true);
        addBtn.parentNode.replaceChild(newAddBtn, addBtn);
        addBtn = newAddBtn;

        var newSkipBtn = skipBtn.cloneNode(true);
        skipBtn.parentNode.replaceChild(newSkipBtn, skipBtn);
        skipBtn = newSkipBtn;
      }
      modalInitialised = true;

      var selectedTier = null;

      function renderGiftStep() {
        selectedGift = null;
        selectedVariantId = null;
        selectedTier = null;
        titleEl.textContent = 'Choose Your Free Gift!';
        giftsEl.innerHTML = '';
        addBtn.disabled = true;
        addBtn.style.display = 'none';
        addBtn.textContent = 'Add Free Gift to Cart';

        var allTierData = data._allTiers || [];
        var cartTotal = data._cartTotal || 0;

        // Use allTiers as the source of truth — determine locked/unlocked by cart total
        // allTiers has full gift data including variant IDs (from tiers endpoint)
        var displayTiers = [];
        if (allTierData.length > 0) {
          // Build tier list with locked status
          var allDisplay = allTierData.map(function(t) {
            return {
              id: t.id,
              name: t.name,
              gifts: t.gifts || [],
              locked: !tierUnlocked(t, data._unlockedIds, cartTotal),
              threshold: t.threshold
            };
          });
          // Unlocked tiers first (highest threshold first), then locked tiers (lowest threshold first)
          var unlocked = allDisplay.filter(function(t) { return !t.locked; }).sort(function(a, b) { return b.threshold - a.threshold; });
          var locked = allDisplay.filter(function(t) { return t.locked; }).sort(function(a, b) { return a.threshold - b.threshold; });
          displayTiers = unlocked.concat(locked);
        } else {
          // Fallback: use eligibility data (unlocked tiers only)
          var unlockedTiers = data.tiers || [{ name: data.tier.name, gifts: data.gifts }];
          unlockedTiers.forEach(function(t) { displayTiers.push({ name: t.name, gifts: t.gifts, locked: false, threshold: 0 }); });
        }

        descEl.textContent = 'Pick a gift as our thank you!';

        displayTiers.forEach(function(tier, tierIndex) {
          if (!tier.gifts || tier.gifts.length === 0) return;

          var wrapper = document.createElement('div');
          wrapper.setAttribute('data-tier-name', tier.name);
          if (tier.locked) wrapper.className = 'pp-tier-locked';

          var heading = document.createElement('div');
          heading.className = 'pp-tier-heading';
          heading.innerHTML = esc(tier.name);
          if (!tier.locked) heading.innerHTML += ' <span class="pp-tier-badge">Unlocked</span>';
          if (tier.locked) heading.innerHTML += ' <span class="pp-tier-badge">Locked</span>';
          wrapper.appendChild(heading);

          if (tier.locked && tier.threshold > 0) {
            var unlockMsg = document.createElement('div');
            unlockMsg.className = 'pp-tier-unlock-msg';
            var sym = currencyCode === 'GBP' ? '£' : currencyCode === 'EUR' ? '€' : currencyCode === 'USD' ? '$' : currencyCode + ' ';
            var remaining = remainingToUnlock(tier.threshold, data, cartTotal);
            unlockMsg.textContent = 'Spend ' + sym + remaining + ' more to unlock';
            wrapper.appendChild(unlockMsg);
          }

          tier.gifts.forEach(function(gift) {
            var el = document.createElement('div');
            el.className = 'pp-gift';

            var mediaHtml = gift.imageUrl
              ? '<img src="' + gift.imageUrl + '" alt="' + esc(gift.title) + '">'
              : '<div class="pp-gift-placeholder">🎁</div>';

            var priceHtml = gift.price
              ? '<span style="text-decoration:line-through;color:#999;font-size:12px;margin-right:4px">' + (currencyCode === 'GBP' ? '£' : currencyCode === 'EUR' ? '€' : currencyCode === 'USD' ? '$' : currencyCode + ' ') + gift.price.toFixed(2) + '</span>'
              : '';

            var btnLabel = (gift.variants && gift.variants.length === 1) ? 'Add' : 'Select';
            var inlineBtnHtml = '<button class="pp-variant-add" style="background:#000;color:#fff;border:none;padding:8px 16px;border-radius:6px;font-size:13px;font-weight:600;cursor:pointer;white-space:nowrap;flex-shrink:0;' + (tier.locked ? 'display:none' : '') + '">' + btnLabel + '</button>';

            el.innerHTML = mediaHtml +
              '<div style="flex:1">' +
                '<div class="pp-gift-title">' + esc(gift.title) + '</div>' +
                '<div class="pp-gift-free">' + priceHtml + 'FREE</div>' +
              '</div>' +
              inlineBtnHtml;

            var inlineBtn = el.querySelector('.pp-variant-add');
            if (gift.variants && gift.variants.length === 1) {
              inlineBtn.addEventListener('click', function(e) {
                e.stopPropagation();
                selectedGift = gift;
                selectedTier = tier;
                selectedVariantId = gift.variants[0].id;
                giftsEl.querySelectorAll('.pp-variant-add').forEach(function(btn) { btn.disabled = true; btn.style.opacity = '0.4'; });
                inlineBtn.textContent = 'Adding...';
                doAddGift();
              });
            } else if (gift.variants && gift.variants.length > 1) {
              inlineBtn.addEventListener('click', function(e) {
                e.stopPropagation();
                renderVariantStep(gift, tier);
              });
            }

            wrapper.appendChild(el);
          });

          giftsEl.appendChild(wrapper);
        });
      }

      function renderVariantStep(gift, tier) {
        selectedGift = gift;
        selectedTier = tier || selectedTier;
        selectedVariantId = null;
        titleEl.textContent = gift.title;
        descEl.textContent = 'Choose your preferred option:';
        giftsEl.innerHTML = '';
        addBtn.disabled = true;
        addBtn.textContent = 'Add Free Gift to Cart';

        addBtn.style.display = 'none';

        gift.variants.forEach(function(variant) {
          var el = document.createElement('div');
          el.className = 'pp-gift';
          el.style.cursor = 'default';

          var mediaHtml = variant.imageUrl
            ? '<img src="' + variant.imageUrl + '" alt="' + esc(variant.title) + '">'
            : '';

          var varPriceHtml = variant.price
            ? '<span style="text-decoration:line-through;color:#999;font-size:12px;margin-right:4px">£' + variant.price.toFixed(2) + '</span>'
            : '';

          el.innerHTML = mediaHtml +
            '<div style="flex:1">' +
              '<div class="pp-gift-title">' + esc(variant.title) + '</div>' +
              '<div class="pp-gift-free">' + varPriceHtml + 'FREE</div>' +
            '</div>' +
            '<button class="pp-variant-add" style="background:#000;color:#fff;border:none;padding:8px 16px;border-radius:6px;font-size:13px;font-weight:600;cursor:pointer;white-space:nowrap;flex-shrink:0">Add</button>';

          el.querySelector('.pp-variant-add').addEventListener('click', function(e) {
            e.stopPropagation();
            selectedGift = gift;
            selectedTier = selectedTier || (data.tiers ? data.tiers[0] : data.tier);
            selectedVariantId = variant.id;
            // Disable all add buttons
            giftsEl.querySelectorAll('.pp-variant-add').forEach(function(btn) {
              btn.disabled = true;
              btn.style.opacity = '0.4';
            });
            e.target.textContent = 'Adding...';
            doAddGift();
          });

          giftsEl.appendChild(el);
        });

        var backEl = document.createElement('button');
        backEl.className = 'pp-skip';
        backEl.textContent = '← Back to gifts';
        backEl.addEventListener('click', function() {
          renderGiftStep();
        });
        giftsEl.insertBefore(backEl, giftsEl.firstChild);
      }

      function doAddGift() {
        if (!selectedVariantId) return;

        // If the basket changed (via cart:updated → maybeRefreshTiersForBasket
        // → __pp_applyFreshTiers) between modal-open and Add-click, the
        // user's selected variant might no longer exist in the new tier
        // catalogue. Surface that politely and bail before any cart mutation.
        var selectionStillValid = false;
        var allTiers = (cachedData && cachedData._allTiers) || [];
        for (var i = 0; i < allTiers.length && !selectionStillValid; i++) {
          var gifts = (allTiers[i] && allTiers[i].gifts) || [];
          for (var j = 0; j < gifts.length && !selectionStillValid; j++) {
            var vs = (gifts[j] && gifts[j].variants) || [];
            for (var k = 0; k < vs.length; k++) {
              if (vs[k] && vs[k].id === selectedVariantId) {
                selectionStillValid = true;
                break;
              }
            }
          }
        }
        if (!selectionStillValid) {
          var addBtnEl = document.getElementById('pp-add-btn');
          if (addBtnEl) {
            addBtnEl.disabled = false;
            addBtnEl.textContent = 'Add Free Gift to Cart';
          }
          var warnEl = document.getElementById('pp-discount-warning');
          if (warnEl) {
            warnEl.style.display = 'block';
            warnEl.textContent = 'Your basket changed and that gift is no longer available — please choose another.';
          }
          selectedVariantId = null;
          selectedGift = null;
          if (typeof renderGiftStep === 'function') renderGiftStep();
          return;
        }

        if (claimAttemptActive) return;
        var numericId = selectedVariantId.replace(/\D/g, '');
        var lineProps = {
          '_milestone_gift': 'true',
          '_tier_id': selectedTier ? selectedTier.id : data.tier.id,
          '_gift_id': selectedGift ? selectedGift.id : '',
          'Free Gift': selectedTier ? selectedTier.name : data.tier.name
        };
        var attemptId = (++claimAttemptSeq) + '-' + Math.random().toString(36).slice(2, 10); // unique across tabs
        var swapDone = false;
        var claimedCode = null;
        claimAttemptActive = true;
        showClaimWarning(null);

        // The marker goes up before anything else: once approved, the swap briefly leaves a
        // gift line with no applicable code, and no progress bar (this tab or another) may
        // auto-remove it meanwhile. It lapses by itself after 30 s.
        markClaimInFlight(attemptId);

        // Step 3 (once approved, below): Apply discount code via full page navigation
        // /discount/CODE redirects and sets the discount on the session
        // Set a grace flag so the progress bar doesn't auto-remove the gift
        // before Shopify has propagated the discount to /cart.js
        // (Storage writes are best-effort: a full or blocked store must not stop the code
        // being applied.)
        function applyClaimedCode() {
          try { sessionStorage.setItem('pp_discount_redirect', String(Date.now())); } catch (e) {}
          // Store code so checkout intercept can re-apply if displaced
          try { sessionStorage.setItem('pp_discount_code', claimedCode); } catch (e) {}
          // Renew, don't clear, the marker: other tabs must leave the new gift alone until
          // Shopify has applied the code.
          markClaimInFlight(attemptId);
          overlay.classList.remove('pp-visible');
          // Chain through /discount/clear first to wipe any stale gift codes
          // from the session before applying the new one. Without this,
          // old codes accumulate as applicable:false and can prevent the
          // new code from taking effect (especially on mobile).
          var applyUrl = '/discount/' + encodeURIComponent(claimedCode) + '?redirect=/cart';
          window.location.href = '/discount/clear?redirect=' + encodeURIComponent(applyUrl);
        }

        // Step 1: claim. The basket is only read (for its token), never changed, until approved.
        readCart()
          .then(function(cart) {
            if (cart.token) lastCartToken = cart.token;
            var postCartTotal = (typeof window.__pp_currentCartTotal === 'number')
              ? window.__pp_currentCartTotal
              : (data && data._cartTotal) || 0;
            // Server re-reads the real cart (token) — cart_total is informational only.
            var claimUrl = PP_PROXY + '?action=claim&variant_id=' + encodeURIComponent(selectedVariantId) + '&customer_id=' + customerId +
              '&currency=' + encodeURIComponent(currencyCode) + '&cart_total=' + encodeURIComponent(postCartTotal);
            if (lastCartToken) claimUrl += '&cart=' + encodeURIComponent(lastCartToken);
            if (PP.country) claimUrl += '&country=' + encodeURIComponent(PP.country);
            return fetch(claimUrl, { method: 'POST' }).then(readClaimResponse);
          })
          .then(function(claim) {
            if (claim.disabled === true) throw claimError('disabled');
            var code = typeof claim.code === 'string' ? claim.code : '';
            if (code.toUpperCase().indexOf('PP-') !== 0) throw claimError(claim.error || 'generic');
            claimedCode = code;
            // Step 2: approved — swap the gift lines against the live basket. The server has just
            // deleted the old code, so renew the marker: the swap gets a full 30 s of its own.
            markClaimInFlight(attemptId);
            // The server now judges this customer's basket against the new claim.
            if (typeof window.__pp_forgetTiers === 'function') window.__pp_forgetTiers();
            // Lines an earlier claim left behind are in this basket's old lines anyway; an old
            // record must not outlive them (a later line can reuse a key).
            try { sessionStorage.removeItem(OLD_GIFT_LINES); } catch (e) {}
            // The old code went with the approval: the checkout guard must never re-apply it (P4-9).
            try { sessionStorage.removeItem('pp_discount_code'); } catch (e) {}
            // A basket read that fails is tried once more a second later (P4-9).
            return readCart().catch(function() { return later(1000).then(readCart); });
          })
          .then(function(cart) {
            return swapGiftLines(cart, numericId, lineProps);
          })
          .then(function() {
            // The new gift line is in, so only the new code is applied from here on.
            swapDone = true;
            applyClaimedCode();
          })
          .catch(function(err) {
            console.error('[PropPerks] Gift flow error:', err);
            var reason = (err && err.ppReason) || (swapDone ? 'basket_failed' : 'generic');
            // Once approved, carry on (pass-4 P4-9): the server has deleted the old code, so
            // whatever else failed (the basket couldn't be read even on a second try, or an
            // unexpected error mid-swap) the new code is stored and applied, and the bar on the
            // basket page sorts out the lines. Not after a refused add (add_failed): that gift
            // isn't in the basket, so its code would discount nothing; the customer chooses again.
            if (claimedCode && !swapDone && !(err && err.ppReason)) {
              try { applyClaimedCode(); return; } catch (e) { reason = 'basket_failed'; }
            }
            // Nothing is rolled back (pass-3 P3-16): before approval the basket was never
            // touched, and after it the server has deleted the old code, so a new gift line
            // holds the only live code.
            clearClaimInFlight(attemptId);
            claimAttemptActive = false;
            showClaimFailure(reason);
            // After approval the old gift line has no code: have the bar and the checkout guard
            // read the basket again rather than trust the last read (P4-9).
            if (claimedCode && typeof window.__pp_refreshBasket === 'function') setTimeout(window.__pp_refreshBasket, 500);
          });
      }

      function showClaimFailure(reason) {
        if (reason === 'disabled') {
          // Programme paused server-side. Only reachable from a tab that
          // was already open when the flag flipped — on a fresh load the
          // modal cannot open at all. Close it rather than offering a
          // retry that cannot succeed.
          overlay.classList.remove('pp-visible');
          return;
        }
        if (CLAIM_NO_RETRY[reason]) {
          // A retry can't succeed: stop offering gifts, and re-ask the server on the next page.
          try { sessionStorage.removeItem('pp_status_' + customerId); } catch (e) {}
          addBtn.style.display = 'none';
          giftsEl.querySelectorAll('.pp-variant-add').forEach(function(btn) { btn.style.display = 'none'; });
        } else if (CLAIM_CHOOSE_AGAIN[reason]) {
          renderGiftStep();
        } else {
          addBtn.disabled = false;
          addBtn.style.display = '';
          addBtn.textContent = 'Add Free Gift to Cart';
        }
        showClaimWarning(CLAIM_MESSAGES[reason] || CLAIM_MESSAGES.generic);
      }

      addBtn.addEventListener('click', function() {
        addBtn.disabled = true;
        addBtn.textContent = 'Getting your free gift...';
        doAddGift();
      });

      skipBtn.addEventListener('click', function() {
        overlay.classList.remove('pp-visible');
        sessionStorage.setItem('pp_skipped', '1');
      });

      overlay.addEventListener('click', function(e) {
        if (e.target === overlay) {
          overlay.classList.remove('pp-visible');
        }
      });

      renderGiftStep();
      overlay.classList.add('pp-visible');
    }

    // Update tier locked/unlocked state in the modal based on current cart total
    window.__pp_updateModalTiers = function(cartTotal, tiers) {
      if (!tiers) return;
      var giftsEl = document.getElementById('pp-gifts');
      if (!giftsEl) return;

      tiers.forEach(function(t) {
        var wrapper = giftsEl.querySelector('[data-tier-name="' + t.name + '"]');
        if (!wrapper) return;
        var wasLocked = wrapper.classList.contains('pp-tier-locked');
        var nowUnlocked = cartTotal >= t.displayThreshold;

        if (nowUnlocked && wasLocked) {
          wrapper.classList.remove('pp-tier-locked');
          var badge = wrapper.querySelector('.pp-tier-badge');
          if (badge && badge.textContent === 'Locked') badge.remove();
          var unlockMsg = wrapper.querySelector('.pp-tier-unlock-msg');
          if (unlockMsg) unlockMsg.remove();
          wrapper.querySelectorAll('.pp-variant-add').forEach(function(btn) {
            btn.style.display = '';
          });
        } else if (!nowUnlocked && !wasLocked) {
          // Shouldn't happen normally but handle cart decrease
          wrapper.classList.add('pp-tier-locked');
        }
      });
    };
  })();
